import { render } from "./ClienteFacturaList.vue?vue&type=template&id=13d4892d&scoped=true"
import script from "./ClienteFacturaList.vue?vue&type=script&lang=js"
export * from "./ClienteFacturaList.vue?vue&type=script&lang=js"

import "./ClienteFacturaList.vue?vue&type=style&index=0&id=13d4892d&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d4892d"]])

export default __exports__